import http from '@/api/http'
import * as qs from 'qs'

interface State {
  enabledInfinite: boolean
  page: number
  infiniteTimer: number
  hasNoticeBadge: boolean
  hasUnreadInfo: boolean
  infomations: any
  syslogs: any[]
  syslogsIndex: number
}

const defaultState: State = {
  enabledInfinite: false,
  page: 0,
  infiniteTimer: null,
  hasNoticeBadge: false,
  hasUnreadInfo: false,
  infomations: {},
  syslogs: [],
  syslogsIndex: 0
}

const state: State = Object.assign({}, defaultState)

const mutations = {
  resetState(state: State) {
    const s = defaultState
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },

  clearSyslogs(state: State) {
    state.syslogs = []
    state.syslogsIndex = 0
  },
  clearInfomations(state: State) {
    state.infomations = {}
  },

  setEnabledInfinite(state: State, enabledInfinite: boolean) {
    state.enabledInfinite = enabledInfinite
  },

  setPage(state: State, page: number) {
    state.page = page
  },

  incrementPage(state: State) {
    state.page++
  },

  setHasNoticeBadge(state: State, hasNoticeBadge: boolean) {
    state.hasNoticeBadge = hasNoticeBadge
  },

  setHasUnreadInfo(state: State, hasUnreadInfo: boolean) {
    state.hasUnreadInfo = hasUnreadInfo
  },

  setInfomations(state: State, infomations: any) {
    state.infomations = infomations
  },

  setSyslogs(state: State, syslogs: any) {
    const keys = Object.keys(syslogs)
    if (keys.length === 0) {
      return
    }

    for (let i = 0; i < keys.length; i++) {
      if (keys[i] === 'is_remainning') {
        continue
      }
      state.syslogs[state.syslogsIndex] = syslogs[keys[i]]
      state.syslogsIndex++
    }
    state.syslogs = Object.assign([], state.syslogs)
  }
}

const actions = {
  /**
   * 未読のお知らせがあるかチェックする
   */
  async checkHasUnreadNotice({ commit }) {
    const res = await http.post(
      '/osirase/',
      qs.stringify({
        page: 'check_unread'
      })
    )
    commit('setHasNoticeBadge', res.data.has_unread)
    commit('setHasUnreadInfo', res.data.has_unread_info)
  },

  /**
   * お知らせ一覧を取得する
   */
  async getInfomations({ commit }) {
    try {
      if (state.page === 0) {
        commit('clearInfomations')
        commit('setEnabledInfinite', false)
      }
      const res = await http.post(
        '/osirase/',
        qs.stringify({
          page: 'get_init',
          p: state.page
        })
      )
      if (res.data.infomations.is_remainning) {
        commit('setEnabledInfinite', true)
        commit('incrementPage')
      } else {
        commit('setEnabledInfinite', false)
      }
      commit('setInfomations', res.data.infomations)
    } catch (err) {
      console.error(err)
    }
  },

  /**
   * システムログ一覧を取得する
   */
  async getSyslogs({ state, commit }) {
    try {
      if (state.page === 0) {
        commit('clearSyslogs')
        commit('setEnabledInfinite', false)
      }
      const res = await http.post(
        '/osirase/',
        qs.stringify({
          page: 'get_syslog',
          p: state.page
        })
      )

      commit('setSyslogs', res.data.syslogs)
      if (res.data.syslogs.is_remainning) {
        commit('setEnabledInfinite', true)
        commit('incrementPage')
      } else {
        commit('setEnabledInfinite', false)
      }
      return res.data
    } catch (err) {
      console.error(err)
    }
  },

  /**
   * システム通知の無限スクロール
   */
  async infiniteSyslogs({ commit, dispatch, state }, $state: any) {
    // 次の load 中なら何もしない
    if (state.infiniteTimer) {
      return
    }
    console.log('[infinite]')

    // ページをインクリメントしてから次ページのデータを取得
    const data = await dispatch('getSyslogs')
    if (!data || !data.syslogs || Object.keys(data.syslogs).length === 0) {
      console.log('[infinite] complete')
      commit('setEnabledInfinite', false)
      $state.complete()
      return
    }

    // 500ms 後にロードアニメーション終了
    state.infiniteTimer = setTimeout(() => {
      $state.loaded()
      clearTimeout(state.infiniteTimer)
      state.infiniteTimer = null
      console.log('[infinite] done')
    }, 300)
  }
}

const getters = {
  enabledInfinite: (state: State): boolean => state.enabledInfinite,
  page: (state: State): number => state.page,
  hasNoticeBadge: (state: State): boolean => state.hasNoticeBadge,
  hasUnreadInfo: (state: State): boolean => state.hasUnreadInfo,
  infomations: (state: State): any => state.infomations,
  syslogs: (state: State): any[] => state.syslogs
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
